<template>
  <section class="metadata-container">
    <div class="metadata-box">
      <div>
        <p class="text-subtle">Typ av ansökan</p>
        <h2>{{ typeLabel }}</h2>
      </div>
      <div v-if="isTopupApplication">
        <p class="text-subtle">Utökning av befintligt bolån</p>
        <AppRouterLink v-if="form.debtId" :to="`/bolan/${form.debtId}`">
          {{ collateralAddress ?? 'Visa bolånet' }}
        </AppRouterLink>
        <p v-else>{{ collateralAddress ?? 'Saknar adress' }}</p>
      </div>
      <div>
        <AppSelect
          v-model="form.brokerPersonnelUserId"
          label="Handläggare"
          :options="personnelOptions"
          :disabled="isLoadingPersonnel"
          placeholder="Välj handläggare"
        />
      </div>
    </div>
  </section>
</template>

<script setup lang="ts">
import { computed } from 'vue'
import { AppSelect } from '@staff/ui'
import AppRouterLink from '@/components/AppRouterLink.vue'
import { usePersonnelDirectory } from '@/composables/usePersonnelDirectory'
import { formatAddress } from '@/utils/formatAddress'
import { useApplicationFormData } from '../composables/applicationFormData'

defineProps<{
  typeLabel: string
}>()

const { personnelOptions, isLoadingPersonnel } = usePersonnelDirectory()
const { form, isTopupApplication } = useApplicationFormData()

const collateralAddress = computed(() => {
  if (!form.street) return undefined

  const street = formatAddress({ street: form.street, streetNo: form.streetNo })
  return form.city ? `${street}, ${form.city}` : street
})
</script>

<style scoped lang="scss">
.metadata-container {
  display: flex;
  container-type: inline-size;
  justify-content: flex-end;
}

.metadata-box {
  display: grid;
  width: 100%;
  gap: var(--space-12);
  padding: var(--space-12);
  border: 1px solid var(--color-border-muted);
  border-radius: var(--radius-lg);
  background-color: var(--color-canvas-inset);
}

@container (min-width: 35rem) {
  .metadata-box {
    width: auto;
    min-width: 35rem;
    grid-template-columns: 1fr 1fr;
  }
}
</style>
